// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"44afeee6","107":"fa97f550","121":"4a425e83","225":"80d98233","283":"c33a147e","522":"518c47c5","582":"f51815ae","596":"0319a5e6","670":"ef32d6b7","737":"7f3207d7","787":"1e652e30","829":"f4c0499c","867":"d4bf2092","948":"c071bda7","951":"8f26d845","961":"59122925"}[chunkId] + ".chunk.js";
};